import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
// 加载 element 组件库
import ElementUI from 'element-ui'
import { location  } from "./api/loa.js" 
import '@/assets/ttf.css'
// 加载 element 组件库的样式
import 'element-ui/lib/theme-chalk/index.css'
// import './assets/element-variables.scss' 
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
import Public from './api/loa.js'
import Md5 from "js-md5"
Vue.prototype.$Public = Public;
Vue.prototype.$md5 = Md5
// 共用组件
import bottomPass from '@/components/bottom_pass.vue'
import topNavigation from '@/components/top_navigation.vue'
import login from '@/components/login/index.vue'
Vue.component('topNavigation',topNavigation)
Vue.component('bottomPass',bottomPass)
Vue.component('login',login)
 Vue.prototype.$imgUrl = 'https://junyiyunpan-1302085701.cos.ap-beijing.myqcloud.com/office_website/assets/'
// 全局注册 element 组件库
Vue.use(ElementUI)
// Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false
Vue.prototype.$location = location
var _hmt = _hmt || [];
window._hmt = _hmt; // 修改为window 全局变量
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?a3ae0facda719418c0c882ab8884cc72";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();
// Vue.prototype.$imgUrl = '../../static/img/'
new Vue({
  render: h => h(App),
  router
}).$mount('#app')